import { InjectionToken, Signal } from '@angular/core';
import { DataSource } from '@softapps/core';
import type { PageFilterService } from '../services/page-filter.service';
import type { FilterTemplateService } from '../../services/filter-template.service';
import type { PageFilterItem } from './page-filter-item';

export const SOFTLINE_SERVICE_DATA_SOURCE = new InjectionToken<DataSource<any>>('SOFTLINE_SERVICE_DATA_SOURCE')

export interface PageFilterOpenOptions {
  view?: 'filter' | 'templates';
  /** opens the list tab on this item's detail view; a toggle item's row is scrolled into view and focused instead */
  item?: PageFilterItem<any, any>;
}

export interface PageFilterRef {
  readonly opened: Signal<boolean>;
  /** committed/draft filter state - lets a host render soft-page-filter-menu-bar itself */
  readonly service: PageFilterService;
  /** null when pageFilter() was created without a `key` */
  readonly templateService: FilterTemplateService | null;

  open(options?: PageFilterOpenOptions): void;
  close(): void;

  dispose(): void;
}
